export const GENDER = ["Male", "Female"] as const;

export const getGenderDescriptor = (gender: string): string => {
  return gender === "Male" ? "" : "";
};
